import { priceBookEntryIdFormat } from "@redotech/redo-ids/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deletePriceBookEntry = unaryRpc({
  name: "deletePriceBookEntry" as const,
  input: z.object({ entryId: priceBookEntryIdFormat.schema }),
  output: z.object({}),
});
